import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7ecf922b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "toast-notification-panel" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("toast-notifications", { timeout: "7000" }, null, -1 /* HOISTED */))
const _hoisted_3 = [
  _hoisted_2
]

import { onMounted } from 'vue'
import { notificationsModule } from '@/services/notifications'


export default /*#__PURE__*/_defineComponent({
  __name: 'ToastNotificationsVue',
  setup(__props) {

onMounted(async () => {
  // load <toast-notifications> component dynamically
  await notificationsModule.getModule('./toastNotifications')
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, _hoisted_3))
}
}

})